import React, { useState, useEffect } from "react";
import "../Survey/SurveyPage.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { contentPlanActions, postActions, } from "../../store";
import { Layout, Row, Col, Card, Space, Typography, Button, Divider, Tabs, Drawer, Avatar, notification, message } from "antd";
import { ThunderboltOutlined, EyeOutlined, LinkedinOutlined, InstagramOutlined, FacebookOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import AudioRecorder from "audio-recorder-polyfill";
import { fetchWrapper } from "../../helpers";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { SETTINGS } from "../../constants/settings";
import { StickyNavigationHeader } from "../../components/Navigation/StickyNavigationHeader";

const baseUrl = `${process.env.REACT_APP_API_URL}`;
export const CreatePost = ({ openNotification }) => {
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const memoizedPostFormats = JSON.parse(localStorage.getItem("postFormats")) || undefined;
    window.MediaRecorder = AudioRecorder;
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const contentPlan = useSelector((obj) => obj.contentPlan.contentPlan);
    const postLoading = useSelector((obj) => obj.post.loading);
    const [isMicActive, setIsMicActive] = useState(false);
    const [answer, setAnswer] = useState("");
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [postModel, setPostModel] = useState(memoizedPostFormats?.postModel || SETTINGS.POST_MODEL.DEFAULT);
    const [postLength, setPostLength] = useState(memoizedPostFormats?.postLength || SETTINGS.POST_LENGTH.DEFAULT);
    const [postEmojis, setPostEmojis] = useState(memoizedPostFormats?.postEmojis || SETTINGS.POST_EMOJIS.DEFAULT);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [contentFormats, setContentFormats] = useState([]);
    const [selectedContentFormatId, setSelectedContentFormatId] = useState(null);
    const [selectedContentLangs, setSelectedContentLangs] = useState(memoizedPostFormats?.contentLangs || []);
    const currentLang = i18n.language;
    console.log("Current lang: ", currentLang);

    useEffect(() => {
        return () => {
            mediaRecorder?.state === "recording" && mediaRecorder.stop();
        };
    }, [mediaRecorder]);

    const openNotificationEndSubscribe = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/subscription-plans")}>
                    {t("posts.goToRate")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("functions.error"),
            description: t("posts.limit"),
            btn,
            key,
        });
    };

    const submitAnswer = async () => {
        if (answer.length > 2000) {
            message.error(t("functions.maxTextLength", { limit: 2000 }));
            return;
        }

        message.loading(t("functions.generatingPost"));
        const requestBody = {
            id: contentPlan.id,
            details: answer,
            formatId: safeFormatId,
            selectedContentLangs: selectedContentLangs,
            postLength: postLength,
            postEmojis: postEmojis,
            postModel: postModel,
        };
        // dispatch()
        if (answer) {
            await dispatch(contentPlanActions.createContentPlanDetails(requestBody));
        }

        await dispatch(postActions.generatePost({ contentPlanId: contentPlan.id, reqBody: requestBody })).then((res) => {
            if (res.error === "Достигнут лимит действий") {
                openNotificationEndSubscribe();
            } else {
                if (res.error) {
                    openNotification();
                }
            }
        });

        // try {
        //   await dispatch(postActions.generatePost(contentPlan.id));
        // } catch {
        //   // openNotification();
        // }
    };


    const safeFormatId = React.useMemo(() => {
        const n = Number(selectedContentFormatId);
        return Number.isFinite(n) ? n : selectedContentFormatId;
    }, [selectedContentFormatId]);

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/postformats`).then((res) => {
            setContentFormats(res);
        });
    }, []);

    return (
        <Layout style={{ minHeight: "100vh", background: "linear-gradient(180deg, #ffffff, #faf5ff)" }}>
            {/* TOP BAR */}
            <StickyNavigationHeader headerTitle={t("post.headerCreate") || "Create Post"} onBackClick={() => navigate("/content-plan")} />

            {/* CONTENT */}
            <Layout.Content style={{ maxWidth: 1200, margin: "24px auto", width: "100%", padding: "0 16px" }}>
                {contextHolder}
                {notificationContextHolder}

                <Row gutter={[16, 16]}>

                    {/* RIGHT COLUMN */}
                    <Col xs={24} lg={10}>
                        {/* Preview */}
                        <Card className="shadow-sm" bodyStyle={{ padding: 16 }}>
                            <Space align="center" size={8} style={{ marginBottom: 8 }}>
                                <EyeOutlined />
                                <Typography.Title level={5} style={{ margin: 0 }}>
                                    Live Preview
                                </Typography.Title>
                            </Space>
                            <Divider style={{ margin: "12px 0" }} />

                            <Tabs defaultActiveKey="linkedin">
                                <Tabs.TabPane
                                    tab={
                                        <Space>
                                            <LinkedinOutlined />
                                            LinkedIn
                                        </Space>
                                    }
                                    key="linkedin">
                                    <Card size="small" bordered>
                                        <Space align="center" size={8} style={{ marginBottom: 12 }}>
                                            <Avatar size={32} style={{ background: "#1677ff" }}>
                                                IN
                                            </Avatar>
                                            <Space direction="vertical" size={0}>
                                                <Typography.Text strong>Company Page</Typography.Text>
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {t("common.now")}
                                                </Typography.Text>
                                            </Space>
                                        </Space>
                                        <Typography.Paragraph type="secondary">{answer?.length ? answer.slice(0, 220) + (answer.length > 220 ? "…" : "") : t("postPage.hint.previewHint")}</Typography.Paragraph>
                                    </Card>
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    tab={
                                        <Space>
                                            <InstagramOutlined />
                                            Instagram
                                        </Space>
                                    }
                                    key="instagram">
                                    <Card size="small" bordered>
                                        <div style={{ aspectRatio: "1/1", width: "100%", background: "#f0f0f0", borderRadius: 12 }} />
                                        <div style={{ height: 8, width: "60%", background: "#f0f0f0", borderRadius: 6, marginTop: 12 }} />
                                        <div style={{ height: 8, width: "40%", background: "#f0f0f0", borderRadius: 6, marginTop: 8 }} />
                                    </Card>
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    tab={
                                        <Space>
                                            <FacebookOutlined />
                                            Facebook
                                        </Space>
                                    }
                                    key="facebook">
                                    <Card size="small" bordered>
                                        <Space align="center" size={8} style={{ marginBottom: 12 }}>
                                            <Avatar size={32} style={{ background: "#1677ff" }}>
                                                FB
                                            </Avatar>
                                            <Space direction="vertical" size={0}>
                                                <Typography.Text strong>Business Page</Typography.Text>
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {t("common.now")}
                                                </Typography.Text>
                                            </Space>
                                        </Space>
                                        <div style={{ height: 8, width: "100%", background: "#f0f0f0", borderRadius: 6 }} />
                                        <div style={{ height: 8, width: "80%", background: "#f0f0f0", borderRadius: 6, marginTop: 8 }} />
                                    </Card>
                                </Tabs.TabPane>
                            </Tabs>
                        </Card>

                        {/* Tips */}
                        <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                            <Space direction="vertical" style={{ width: "100%" }} size={12}>
                                <Typography.Title level={5} style={{ margin: 0 }}>
                                    {t("postPage.cards.tipsTitle") || "Tips"}
                                </Typography.Title>
                                <Space align="center" size={8} style={{ color: "#8c8c8c" }}>
                                    <QuestionCircleOutlined /> {t("assistant.shortcutSend") || "Send: Ctrl+Enter"}
                                </Space>
                                <Space align="center" size={8} style={{ color: "#8c8c8c" }}>
                                    <QuestionCircleOutlined /> {t("assistant.shortcutPaste") || "Paste: Ctrl+V"}
                                </Space>
                                <Divider style={{ margin: "8px 0" }} />
                                <Space>
                                    <Button onClick={() => setDrawerVisible(true)}>{t("postPage.buttons.settings")}</Button>
                                    <Button type="primary" icon={<ThunderboltOutlined />} loading={postLoading} onClick={submitAnswer}>
                                        {t("functions.generate")}
                                    </Button>
                                </Space>
                            </Space>
                        </Card>
                    </Col>
                </Row>

                {/* Settings Drawer (uses your existing state; content optional) */}
                <Drawer title={t("postPage.buttons.settings")} open={drawerVisible} onClose={() => setDrawerVisible(false)} width={420}>
                    <Space direction="vertical" style={{ width: "100%" }}>
                        <Typography.Text type="secondary">{t("home.formatPost") || "Tune languages, length, emojis, and format before generating."}</Typography.Text>
                        {/* You can drop additional controls here reusing the same handlers */}
                    </Space>
                </Drawer>
            </Layout.Content>
        </Layout>
    );
};
